
import Panel from 'vux/src/components/panel/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'

import XHeader from 'vux/src/components/x-header/index.vue'

import { canAccessWordIndex, trialWordLimitToast } from '@/utils/trialAccess'
export default {
components: {
Panel,
Group,
Radio,
XHeader,
},
computed: {
navTitle() {
const title = this.book.unitEn || ''
return title.length > 14 ? title.substring(0, 14) + '…' : title
}
},
methods: {
goBack: function () {
this.$router.push({ path: '/home?hideTrans=true' })
},
goReturn() {
this.$router.push({ path: '/pmsCellList_display', query: this.$route.query });
},
getWordById(id, index1) {
if (this.$route.query.isPower == 0) {
this.$toast('目前没有购买该书本， \n请联系管理员购买。');
return false;
}
if (!canAccessWordIndex(this.isWordPower, index1)) {
this.$toast(trialWordLimitToast());
return;
}
let book = this.$route.query
book.type = 2;
book.id = this.$route.query.unitId;
this.$ajax.post(this.$api.getPmsPmsStudyAdd, {
wordId: id,
wordUnitId: this.$route.query.value,
categoryId: this.$route.query.categoryId || this.$route.query.value
}).then(
(response) => {
this.$router.push({ path: '/cellIndex_display', query: book });
},
(response) => {
that.$vux.loading.hide();
}
);
},
recwordCateFirst(bookId) {
this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: this.$route.query.unitId }).then((result) => {
this.totalUnitList = result;
});
}
},
created() {
this.isWordPower = this.$route.query.isWordPower
this.book = this.$route.query
this.recwordCateFirst(this.$route.query);
},
data() {
return {
book: {},
isWordPower: null,
activeName: '1',
type: "1",
totalUnitList: [],
footer: {
title: "1111",
url: "http://vux.li",
},
};
},
};



// WEBPACK FOOTER //
// ./src/views/word/pmsUnitCellList.vue